import { Card, PageHeading } from "@peer-start/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../app/use-app-context.js";
import { pageDefinitions } from "../../../app/page-references.js";
import { ManagerRankingList } from "../components/ManagerRankingList.js";
import { leastRecommendedCourses, rankedCourses } from "../data/manager-dashboard.js";

export function ManagerCourseRankingPage() {
  const { t } = useTranslation();
  const { persona } = useAppContext();
  if (persona.kind === "employee") return null;

  const ranked = rankedCourses();
  const least = leastRecommendedCourses();
  const row = (course: (typeof ranked)[number]) => ({
    id: course.id,
    title: course.title,
    meta: course.domain,
    value: course.recommendations,
    valueText: t("managerDashboard.courses.count", { count: course.recommendations }),
  });

  return (
    <>
      <PageHeading
        action={
          <Link
            className="text-sm font-medium text-link hover:underline focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
            data-control-id="manager.ranking.back"
            to={pageDefinitions.managerDashboard.path}
          >
            {t("managerDashboard.ranking.back")}
          </Link>
        }
        subtitle={t("managerDashboard.ranking.subtitle")}
        title={t("managerDashboard.ranking.title")}
      />
      <div className="grid gap-5 xl:grid-cols-[1.2fr_0.8fr]">
        <Card>
          <h2 className="mb-5 text-base font-medium">{t("managerDashboard.ranking.all")}</h2>
          <ManagerRankingList rows={ranked.map(row)} />
        </Card>
        <Card>
          <h2 className="text-base font-medium">{t("managerDashboard.ranking.leastTitle")}</h2>
          <p className="mt-1 mb-5 text-sm text-muted-foreground">{t("managerDashboard.ranking.leastHint")}</p>
          <div data-control-id="manager.ranking.least">
            <ManagerRankingList
              barClassName="bg-foreground/35"
              maxValue={ranked[0]?.recommendations}
              rows={least.map(row)}
              startRank={ranked.length - least.length + 1}
            />
          </div>
        </Card>
      </div>
    </>
  );
}
